// extracted by mini-css-extract-plugin
module.exports = {"hoverTransaction":"transactions_editor_hoverTransaction___QeHx","addTransactionBox":"transactions_editor_addTransactionBox__4KoMA"};